import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'

// Components
import SEO from '../../components/seo'
import Hero from '../../components/hero'
import NewsletterPrimary from '../../components/newsletterPrimary'
import CharityCallout from '../../components/charityCallout'
import SliceZone from '../../components/sliceZone'

// Strings
import strings from './strings'

// Styles
const useStyles = makeStyles((theme) => ({
  sliceGrid: {
    display: 'grid',
    gap: theme.spacing(2),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(8),
  },
  grid: {
    display: 'grid',
    gap: theme.spacing(8),
  },
  newsletter: {
    [theme.breakpoints.only('xs')]: {
      marginLeft: theme.spacing(-2),
      marginRight: theme.spacing(-2),
    },
  },
}))

const CharityPage = (props) => {
  // console.log('👾 CharityPage > ', props)

  const { hero, charity_callout } = props.data.prismicCharity.data

  const bodySlicesData = props.data.prismicCharity.data.body

  const { shopifyThemePath } = props.pageContext

  const classes = useStyles()

  return (
    <>
      <SEO title={strings.seoTitle} shopifyThemePath={shopifyThemePath} />

      <Hero {...hero[0]} link="#" />

      <Container className={classes.sliceGrid}>
        <SliceZone sliceData={bodySlicesData} />
      </Container>

      <Container className={classes.grid}>
        <CharityCallout {...charity_callout[0]} />
        <NewsletterPrimary
          styles={classes.newsletter}
          location="charityPage"
          listId={process.env.GATSBY_KLAVIYO_GENERAL_LIST}
        />
      </Container>
    </>
  )
}

export default CharityPage

CharityPage.propTypes = {}
CharityPage.defaultProps = {}
